<template>
  <a
    v-show="show"
    id="back-to-top"
    href="#"
    :aria-label="t('common.backToTop')"
    class="back-to-top fixed text-lg rounded-md z-10 bottom-5 end-5 size-10 text-center bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white flex justify-center items-center transition-opacity duration-300"
    @click.prevent="scrollToTop"
  >
    <Icon name="mdi-arrow-up" size="24px" class="text-red-500" aria-hidden="true" />
  </a>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const { t } = useI18n();

const show = ref(false);

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function handleScroll() {
  show.value = window.scrollY > 200;
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>
